import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {
  TuiPrimitiveTextfieldModule,
  TuiTextfieldControllerModule,
  TuiTextareaModule,
  TuiInputModule,
  TuiInputNumberModule,
} from '@taiga-ui/legacy';
import { TuiError, TuiButton } from '@taiga-ui/core';
import { TranslateModule } from '@ngx-translate/core';
import { FieldModule } from '@src/app/shared/field';
import { ContactsModule } from '@src/app/modules/contacts';
import { TestingModule } from '@src/app/modules/testing';
import { ComponentsModule } from '@src/app/components';

import { PageInfoComponent } from './page-info.component';
import { InfoViewComponent, InfoEditComponent } from './components';
import { PageInfoService } from './services';

@NgModule({
  declarations: [PageInfoComponent, InfoViewComponent, InfoEditComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FieldModule,
    TranslateModule,
    TuiButton,
    TuiInputModule,
    TuiError,
    TuiTextareaModule,
    TuiTextfieldControllerModule,
    TuiPrimitiveTextfieldModule,
    TuiInputNumberModule,
    ContactsModule,
    TestingModule,
    ComponentsModule,
  ],
  providers: [PageInfoService],
  exports: [PageInfoComponent],
})
export class PageInfoModule {}
